//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Heading, Box, Text } from 'grommet';

export const ExperienceHome = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background-back">

      <Box background="url('/images/hpe-room.jpg')" height="200px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
                        <PageHeader pad={{ top: '15px', bottom: '15px' }} 
                          title={<Text color="white" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>Driving Our Modern Workplace Experience</Text>} 
                          subtitle={'OneGW and experience from edge to cloud.'}
                          style={{ color: 'white' }}
                          size='medium'/>
        </Box>                  
      </Box> 

      <PageContent flex="grow">

          <Heading size="small" weight="bold" margin={{ top: 'large' }}>Coming soon...</Heading>

      </PageContent>  

    </Page>
  );
};